export interface CallbotWidgetProject {
    callbotWidget?: unknown
}

export function isCallbotWidgetEnabled(project?: CallbotWidgetProject | null): boolean {
    return project?.callbotWidget === true
}
